import React from 'react';
import { useTranslation } from 'react-i18next';
import './Brand.css';
import { FiDownload } from 'react-icons/fi';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';

import logoSignature from '../../images/logo/4S Mapper_LOGO_Signature.png';
import logoBlack from '../../images/logo/4S Mapper_LOGO_black.svg';
import logoWhite from '../../images/logo/4S Mapper_LOGO_white.svg';
import logoSymbol from '../../images/logo/4S Mapper_LOGO_Symbol.png';
import logoVertical from '../../images/logo/4S Mapper_LOGO_Vertical.svg';

const Brand = () => {
  const { t } = useTranslation('brand');

  const colors = [
    {
      key: 'green',
      label: '4S Mapper Green',
      hex: '#6FB838',
      rgb: 'R111, G184, B56',
      cmyk: 'C40 M0 Y70 K28',
      meaning: 'Vitality, Sustainability',
    },
    {
      key: 'blue',
      label: '4S Mapper Blue',
      hex: '#009FE8',
      rgb: 'R0, G159, B232',
      cmyk: 'C82 M32 Y0 K0',
      meaning: 'Trust, Intelligence',
    },
    {
      key: 'red',
      label: '4S Mapper Red',
      hex: '#E50044',
      rgb: 'R229, G0, B68',
      cmyk: 'C0 M100 Y70 K10',
      meaning: 'Innovation, Passion',
    },
    {
      key: 'gray',
      label: '4S Mapper Gray',
      hex: '#888888',
      rgb: 'R136, G136, B136',
      cmyk: 'C0 M0 Y0 K47',
      meaning: 'Balance, Expertise',
    },
  ];

  return (
    <>
      <Header />
      <div className="Header_Block"></div>
      {/* Hero */}
      <div className="Brand_Hero">
        <div className="brand_container">
          <h1 className="brand_title">4S Mapper Brand Identity</h1>
          <div className="brand_subtitle">{t('subtitle1')}</div>
        </div>
      </div>

      {/* Signature (기본형) */}
      <div className="Brand_Section">
        <div className="brand_container">
          <div className="brand_section_head">
            <h2>Signature Logo</h2>
            <div className="brand_subtitle">{t('subtitle2')}</div>
          </div>

          <div className="brand_card brand_card--center">
            <img className="logo_signature" src={logoSignature} alt="4S Mapper Signature Logo" />
            <a className="btn_dl" href="/images/logo/4S Mapper_LOGO_Signature.png" download>
              <FiDownload style={{ marginRight: '0.2vw' }} />
              Download
            </a>
          </div>
        </div>
        <div className=" brand_grid_3">
          <div className="brand_logo_box black">
            <img src={logoBlack} alt="4S Mapper Mono black" />
            <a className="btn_dl" href="/images/logo/4S Mapper_LOGO_black.svg" download>
              <FiDownload style={{ marginRight: '0.2vw' }} />
              Download
            </a>
          </div>
          <div className="brand_logo_box white">
            <img src={logoWhite} alt="4S Mapper Mono white" />
            <a className="btn_dl" href="/images/logo/4S Mapper_LOGO_white.svg" download>
              <FiDownload style={{ marginRight: '0.2vw' }} />
              Download
            </a>
          </div>
        </div>
      </div>
      <div className="Brand_Section">
        <div className="brand_container">
          <div className="brand_section_head">
            <h2>Symbol Logo</h2>
            <div className="brand_subtitle">{t('subtitle3')}</div>
          </div>

          <div className="brand_card brand_card--center">
            <img className="logo_symbol" src={logoSymbol} alt="4S Mapper Signature Logo" />
            <a className="btn_dl" href="/images/logo/4S Mapper_LOGO_Symbol.png" download>
              <FiDownload style={{ marginRight: '0.2vw' }} />
              Download
            </a>
          </div>
        </div>
      </div>
      <div className="Brand_Section">
        <div className="brand_container">
          <div className="brand_section_head">
            <h2>Vertical Logo</h2>
            <div className="brand_subtitle">{t('subtitle4')}</div>
          </div>

          <div className="brand_card brand_card--center">
            <img className="logo_vertical" src={logoVertical} alt="4S Mapper Signature Logo" />
            <a className="btn_dl" href="/images/logo/4S Mapper_LOGO_Vertical.svg" download>
              <FiDownload style={{ marginRight: '0.2vw' }} />
              Download
            </a>
          </div>
        </div>
      </div>

      <div className="Brand_Section">
        <div className="brand_container">
          <div className="brand_section_head">
            <h2>Brand Colors</h2>
            <div className="brand_subtitle">{t('subtitle5')}</div>
          </div>

          <div className="brand_colors">
            {colors.map((c) => (
              <div key={c.key} className={`color_swatch ${c.key}`}>
                <div className="chip" style={{ backgroundColor: c.hex }} />
                <div className="meta">
                  <strong>{c.label}</strong>
                  <span>HEX {c.hex}</span>
                  <span>{c.rgb}</span>
                  <span>{c.cmyk}</span>
                  <span>{c.meaning}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Brand;
